import { useState, useContext, useLayoutEffect } from 'react';

import { POPUP_NAME } from '../constants/index';
import { getCookie, setCookie } from '../helpers/cookies';
import { connect } from 'react-redux';
import { LayoutContext } from '../context/layoutContext';
import MainUrlPopupItem from './MainUrlPopupItem';

const MainUrlPopup = ({ bannerData }) => {
  const { matchese } = useContext(LayoutContext);
  const [banner, setBanner] = useState([]);

  useLayoutEffect(() => {
    console.log(
      'AAAA=',
      bannerData.filter(i => i.category === '팝업'),
    );
    if (bannerData?.length > 0) {
      let banner = bannerData.filter(i => i.category === '팝업'); //.filter(i => i.isShow);

      if (banner?.length > 0) {
        const _banner = [];
        banner.map(async (item, i) => {
          const cookie = getCookie(`${POPUP_NAME}_${item?.id}`) || 'false';

          if (cookie !== 'true') {
            let title = `${POPUP_NAME}_${item?.id}`;

            setCookie(title, false);
            _banner.push(item);
          }
        });

        setBanner(_banner);
      }
    }
  }, [bannerData]);

  return banner && banner?.length > 0 && banner?.map((item, i) => <MainUrlPopupItem key={`popup_${i}`} data={item} position={i} />);
};

const mapStateToProps = state => {
  return {
    bannerData: state.bannerData.banner,
  };
};

export default connect(mapStateToProps)(MainUrlPopup);
